<template>
  <div>
    <span class="class-status" v-if="classData.status !== 'finished' && classData.end_date">{{ distanceBetweenDate(classData) }}</span>
    <!-- <span class="class-status" v-if="classData.status !== 'finished' && classData.end_date && (class.end_date > class.start_date)">{{ distanceBetweenDate(classData) }}</span> -->
    <span class="class-status hidden" v-else>none</span>
    <progress-bar
      class="progress-bar"
      :value="classData.status"
      :percentage="percentage"
      :displayText="false"
    />
    <div class="date-range">
      <span v-if="classData.start_date">{{ formatDate(classData.start_date) }}</span>
      <span v-if="classData.end_date">{{ formatDate(classData.end_date) }}</span>
    </div>
  </div>
</template>

<script>
  import ProgressBar from '@/components/common/ProgressBar'
  import {
    format,
    formatDistance,
  } from 'date-fns'
  import { calculatePercentageOfDateInterval } from '../../utils/dateInterval'
  import { locale_mapping_date } from '@/helpers/languages'

  export default {
    components: {
      ProgressBar,
    },
    props: {
      classData: {
        type: Object,
        default: () => ({})
      },
    },
    methods: {
      formatDate(date) {
        return format(new Date(date), 'dd MMM yyyy', {locale: locale_mapping_date[this.$i18n.locale]})
      },
      distanceBetweenDate(clazz) {
        const startDate = clazz.status === 'active' ? new Date() : new Date(clazz.end_date)
        const endDate = clazz.status === 'active' ? new Date(clazz.end_date) : new Date(clazz.start_date)
        const prefix = clazz.status === 'active' ? this.$t('classes.classes_details.left') : this.$t('classes.classes_details.to_go')

        const distance = formatDistance(
          startDate,
          endDate
        , {locale: locale_mapping_date[this.$i18n.locale]})

        if (this.$i18n.locale == 'vi') 
          return prefix + ' ' + distance
        return  distance + prefix
      },
    },
    computed: {
      percentage() {
        return calculatePercentageOfDateInterval(this.classData.start_date, this.classData.end_date)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/_colors.scss';

  .progress-bar {
    padding-top: 8px;
    padding-bottom: 8px;

    ::v-deep .el-progress.el-progress--line{
      width: 100%;
    }
  }

  .class-status {
    font-family: 'SF Pro Display';
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    text-transform: capitalize;
    color: $dark-blue-2;

    &.hidden {
      visibility: hidden;
    }
  }

  .date-range {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    span {
      font-weight: normal;
      font-size: 12px;
      text-transform: capitalize;
      color: $dark-blue-2;
    }
  }
</style>
